module.exports = __webpack_public_path__ + "img/gwen.756aff90.jpg";